import type { UseInfinityScrollConfig } from '@/shared/lib/scroll/useInfinityScroll';
import { useInfinityScroll } from '@/shared/lib/scroll/useInfinityScroll';
import type { PropsWithChildren } from 'react';
import React, { useEffect, useRef } from 'react';

interface IInfinityScrollContainerProps extends UseInfinityScrollConfig {
	style?: React.CSSProperties;
}

const InfinityScrollContainer: React.FC<PropsWithChildren<IInfinityScrollContainerProps>> = (props) => {
	const {
		hasNextPage,
		loading,
		onLoadMore,
		scrollCheckInterval,
		startObservingDelay,
		direction,
		threshold,
		style,
		children,
	} = props;

	const containerReference = useRef(null);

	const setInfinityScrollContainer = useInfinityScroll({
		direction,
		hasNextPage,
		loading,
		onLoadMore,
		scrollCheckInterval,
		startObservingDelay,
		threshold,
	});

	useEffect(() => setInfinityScrollContainer(containerReference.current));

	return (
		<div ref={containerReference} style={{ ...style, overflow: 'auto' }}>
			{children}
		</div>
	);
};

export default InfinityScrollContainer;
